export default "__VITE_ASSET__D5VPCLAU__"